import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';

const SimpleContact = ({
  heading1 = 'Contact Us',
  content1 = `For inquiries or more information about our industrial machinery products and services, please feel free to reach out to us.`,
  googleFormUrl = 'https://tally.so/embed/wQvEpY?hideTitle=1&transparentBackground=1&dynamicHeight=1',
}) => {
  return (
    <Container className="py-5">
      {/* Heading Section */}
      <Row className="mb-4 text-center">
        <Col>
          <h2 style={{ fontSize: '2rem', fontWeight: 'bold' }}>{heading1}</h2>
          <p style={{ fontSize: '1.25rem', marginTop: '1rem' }}>{content1}</p>
        </Col>
      </Row>

      {/* Google Form Section */}
      <Row className="justify-content-center">
        <Col md={8}>
          <iframe
            src={googleFormUrl}
            title="Google Form"
            width="100%"
            height="460"
            frameBorder="0"
            style={{ border: 'none' }}
            allowFullScreen
          ></iframe>
        </Col>
      </Row>
    </Container>
  );
};

SimpleContact.propTypes = {
  heading1: PropTypes.string,
  content1: PropTypes.string,
  googleFormUrl: PropTypes.string, // The URL of the Google Form
};

export default SimpleContact;